import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a7a626a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-viewer--pdf" }
const _hoisted_2 = {
  key: 0,
  id: "adobe-dc-view"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Poxa, Houve um erro ao carregar o conteúdo.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentFallback = _resolveComponent("ContentFallback")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isPDFRendered)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createBlock(_component_ContentFallback, { key: 1 }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
  ]))
}